import { FaCode, FaTelegramPlane } from "react-icons/fa";
import { BsCloudLightningRainFill, BsGraphUpArrow } from "react-icons/bs";
import { IoLogoAndroid } from "react-icons/io";
import Slider from "react-slick";
import "./Service.css";
import { Link } from "react-router-dom";
function ServiceCard() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container my-3">
      <Slider {...settings}>
        {Services.map((service, key) => {
          return (
            <>
              <div
                className="card service-card shadow mx-3 p-5 text-center"
                key={key}
                data-aos={key % 2 === 0 ? "fade-left" : "fade-right"}
              >
                <div className="text-center text-green">{service.icons}</div>
                <h3>{service.title}</h3>
                <p>
                  {service.desc.slice(0, 80)}
                  {service.desc.length > 80 && "..."}
                </p>
                <div className="text-center">
                  <Link to={service.path} className="btn btn-info fw-bold">
                    Read more
                  </Link>
                </div>
              </div>
            </>
          );
        })}
      </Slider>
    </div>
  );
}
export default ServiceCard;
const Services = [
  {
    path: "/web",
    icons: <FaCode size={40} />,
    title: "Web Development",
    desc: "Create reliable, secure, and robust websites using the MERN Stack and Java technologies.",
  },
  {
    path: "/app",
    icons: <IoLogoAndroid size={40} />,
    title: "App Development",
    desc: "Build mobile apps with native and hybrid technologies, accompanied by admin panel development.",
  },
  {
    path: "/cloud",
    icons: <BsCloudLightningRainFill size={40} />,
    title: "Cloud Computing",
    desc: "Leverage cloud solutions using Github actions and configure virtual private servers (VPS) for your website.",
  },
  {
    icons: <BsGraphUpArrow size={40} />,
    title: "SEO",
    path: "/seo",
    desc: "Drive organic traffic with SEO expertise. Conduct keyword research, optimize content, and analyze performance.",
  },
  {
    icons: <FaTelegramPlane size={40} />,
    title: "Digital Marketing",
    path: "/digital",
    desc: "Execute compelling campaigns across social media, email, and PPC platforms. Achieve brand visibility, lead generation, and conversions through data-driven strategies.",
  },
];
